// src/shared/components/ProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '@/hooks/useAuth';
import { AdminPermissions } from '@/services/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermissions?: Array<keyof AdminPermissions>;
  fallback?: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredPermissions = [],
  fallback = <Navigate to="/auth/login" replace />
}) => {
  const { isAuthenticated, isLoading, permissions } = useAuth();

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <>{fallback}</>;
  }

  // Проверяем права доступа
  if (requiredPermissions.length > 0 && permissions) {
    const hasPermissions = requiredPermissions.every(
      permission => permissions[permission]
    );

    if (!hasPermissions) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
};